import { createContext } from "react";

export const desktopContext = createContext({})